import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import PageWrapper from "./layout/PageWrapper";
import Button from "./forms/Button";
import { FileQuestion, ArrowLeft, LayoutDashboard } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);
  const goToDashboard = () => navigate("/main/dashboard", { replace: true });

  return (
    <PageWrapper
      title="Page Not Found"
      subtitle="The page you're looking for doesn't exist or has been moved"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col items-center justify-center min-h-[60vh]"
      >
        <div className="card shadow-lg max-w-md w-full text-center">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.1, duration: 0.3 }}
              className="w-20 h-20 rounded-full bg-gradient-to-br from-primary-accent/20 to-orange-600/20 dark:from-primary-accent/30 dark:to-orange-600/30 flex items-center justify-center border-2 border-primary-accent/30"
            >
              <FileQuestion className="w-10 h-10 text-primary-accent" strokeWidth={2} />
            </motion.div>
          </div>

          <h2 className="text-4xl font-bold text-primary-accent mb-2">404</h2>
          <h3 className="text-xl font-bold text-gray-900 dark:text-light-100 mb-2">
            Page Not Found
          </h3>
          <p className="text-gray-600 dark:text-light-500 text-sm mb-8">
            The page you requested could not be found. It may have been moved,
            deleted, or the URL might be incorrect.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="secondary"
              onClick={goBack}
              icon={<ArrowLeft className="w-4 h-4" />}
              className="flex items-center justify-center gap-2"
            >
              Go Back
            </Button>
            <Button
              variant="primary"
              onClick={goToDashboard}
              icon={<LayoutDashboard className="w-4 h-4" />}
              className="flex items-center justify-center gap-2"
            >
              Dashboard
            </Button>
          </div>
        </div>
      </motion.div>
    </PageWrapper>
  );
};

export default NotFound;
